import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSoundPacks } from '../context/SoundPacksContext';
import { createStripeCheckoutSession } from '../services/stripe/stripeApi';
import { getStripe } from '../services/stripe/stripeClient';
import { FullPagePreloader } from './ui/Preloader';

function BuyPackPage() {
    const { packId } = useParams<{ packId: string }>();
    const { soundPacks, isLoading: packsLoading } = useSoundPacks();
    const navigate = useNavigate();

    useEffect(() => {
        if (packsLoading || !packId) return;

        const pack = soundPacks.find(p => p.id === packId);
        if (!pack?.priceId) {
            console.error('Pack not found or has no priceId:', packId);
            navigate('/');
            return;
        }

        const initiateCheckout = async () => {
            try {
                const sessionId = await createStripeCheckoutSession(pack.priceId!, 'payment');
                const stripe = await getStripe();
                if (stripe) {
                    await stripe.redirectToCheckout({ sessionId });
                }
            } catch (error) {
                console.error('Error initiating checkout:', error);
                navigate('/');
            }
        };

        initiateCheckout();
    }, [packId, soundPacks, packsLoading, navigate]);

    return <FullPagePreloader />;
}

export default BuyPackPage;
